<template>

<div class="completion-graph">

  <div class="completion-graph__item" v-for="(report,index) in this.reports" :key="index">
    <CompletionGraphItemIpo ref="item" :report="report" />
  </div><!--/completion-graph__item-->
</div>

</template>

<!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/2.1.3/jquery.min.js"></script>-->
<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import CompletionGraphItemIpo from '@/components/parts/human_capital/parts/CompletionGraphItemIpo.vue';

export default {
  components: {
    CompletionGraphItemIpo,
  },
/*  props: {
    corpId: null,
    diagResultId: null,
  },*/
  data() {
    return {
      reports: [],
      report2: {},
      process: 0,
      lineChartData: {
        labels: [],
        datasets: [],
      },
      lineChartOptions: {},
    }
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
  },
  created: async function() {

    if (this.corpId) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/diag/getAchievementSectionData', {
          corpId: this.corpId,
          diagResultId: this.diagResultId,
        });
        if (res.status==200) {
          this.reports = res.data.reports;
        }else{
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
  },
  mounted: function() {
  },
  methods: {
    async changeCorpId(corpId, diagResultId){
      if (corpId) {
          this.isProcessing = true;
          let res = await this.$axios.post('/ld/api/diag/getAchievementSectionData', {
            corpId: corpId,
            diagResultId: diagResultId,
          });
          if (res.status==200) {
            this.corpId = corpId;
            this.reports = res.data.reports;
             await this.$refs.item.changeCorpId(this.reports);
          }else{
            this.$toast.error(res.data.message);
          }
          this.isProcessing = false;
        }
    }
  },
}
</script>

<style scoped>
.chart-area {
  border: 2px solid rgba(220, 220, 220, 0.5);
  border-radius: 10px;
  padding: 10px;
  background-color: rgba(248, 248, 255, 0.5);
}
</style>